/* eslint-disable no-underscore-dangle */
import { useRef, useEffect } from 'react';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import getPosition from '@/helpers/position.js';
import { ORImage } from '@/core/image';
import CarouselEmbla from '@/components/core/carousel-embla';
import { useZusHomeStore } from '@/helpers/context';
import { useTranslation } from '@/helpers/translate';

function MonoSpace({ space }) {
  const markerRef = useRef();
  const { mapRef, languageCurrent } = useSearchZustandStore.getState();
  const { ua } = useZusHomeStore.getState();
  const { t } = useTranslation();

  function getUrl() {
    return `${space?.[`urlSpace${languageCurrent}`]}`;
  }

  useEffect(() => {
    getPosition(markerRef, mapRef, ua.isMobile, true);
    const clickOutside = (e) => {
      if (ua.isMobile && markerRef.current && !markerRef.current.contains(e.target)) {
        useSearchZustandStore.setState({ pinIdOpen: null, pinData: null });
      }
    };
    window.addEventListener('mousedown', clickOutside);
    return () => {
      window.removeEventListener('mousedown', clickOutside);
    };
  }, [markerRef, ua.isMobile]);

  return (
    <div
      onClick={() => { window.open(getUrl(), '_blank'); }}
      ref={markerRef}
      className="font-sans cursor-pointer absolute z-40 w-[280px] bg-white rounded-lg overflow-hidden shadow-button hover:text-black invisible"
    >
      <div className="grid grid-cols-5 lg:contents font-display">
        <div className="relative z-40 w-full col-span-2 lg:static h-28 lg:h-44">
          <CarouselEmbla slidesToScroll={1}>
            {space.pictures.map((picture, index) => (
              <div className="embla__slide__search" key={`searchmapspaceonespace${picture.__id}`}>
                <div className="rounded-lg embla__slide__inner">
                  <div className="w-full rounded-lg h-28 carousel-cell-search lg:h-44 bg-purple-0">
                    <ORImage
                      picture={picture}
                      showDefault
                      noFlickity
                      options={{
                        alt: space.title,
                        index,
                      }}
                      defaultAlt={`${t('search:filter.space')} ${space.title} - ${index}`}
                    />
                  </div>
                </div>
              </div>
            ))}
          </CarouselEmbla>
        </div>
        <div className="flex flex-col justify-between col-span-3 px-4 py-3 lg:py-3">
          <h2 className="pb-1 text-sm text-black text-ellipsis lg:truncate lg:text-dark-deep">{space.title}</h2>
          <span className="block text-sm font-normal">
            <span className="font-medium text-black">
              {Math.round(space?.dataByCategory?.price?.amount_excl_tax)}
              €
            </span>
            <span className="text-dark"> {t('space:per_day')}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

function MultiSpaces({ spaces }) {
  const markerRef = useRef();
  const { mapRef, languageCurrent } = useSearchZustandStore.getState();
  const { ua } = useZusHomeStore.getState();

  useEffect(() => {
    getPosition(markerRef, mapRef, ua.isMobile, true);
    const clickOutside = (e) => {
      if (ua.isMobile && markerRef.current && !markerRef.current.contains(e.target)) {
        useSearchZustandStore.setState({ pinIdOpen: null, pinData: null });
      }
    };
    window.addEventListener('mousedown', clickOutside);
    return () => {
      window.removeEventListener('mousedown', clickOutside);
    };
  }, [markerRef, ua.isMobile]);

  function getUrl(space) {
    return `${space?.[`urlSpace${languageCurrent}`]}`;
  }

  return (
    <div
      ref={markerRef}
      className="absolute z-40 w-[280px] bg-white rounded-xl overflow-hidden shadow-button hover:text-black invisible"
    >
      <div>
        <CarouselEmbla fromCluster slidesToScroll={1}>
          {(spaces || []).map((space, index) => (
            <div
              onClick={() => { window.open(getUrl(space), '_blank'); }}
              className="relative w-full h-full cursor-pointer embla__slide__search"
              key={`searchpinmultispace${space.ref}`}
            >
              <div className="grid grid-cols-5 lg:contents">
                <div className="relative w-full col-span-2 overflow-hidden rounded-lg lg:static h-28 lg:h-44 lg:w-full">
                  {!space?.pictures?.[0] || (
                  <div className="relative w-full h-28 lg:h-44">
                    <ORImage
                      {...{ picture: space.pictures[0] || null }}
                      noFlickity
                      options={{
                        alt: space.title,
                        index,
                      }}
                    />
                  </div>
                  )}
                </div>
                <div className="col-span-3 px-4 pt-8 lg:w-full lg:pt-2 font-display">
                  <div className="">
                    <h2 className="text-sm truncate text-dark-deep lg:w-full">{space.title}</h2>
                      <span className="block text-sm">
                        {Math.round(space?.dataByCategory?.price?.amount)}
                        €
                        <span className="font-normal text-dark"> {t('space:per_day')}</span>
                      </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </CarouselEmbla>

      </div>

    </div>
  );
}

export { MonoSpace, MultiSpaces };
